var map = {
	"./0.1.0/reference.json": 614,
	"./0.10.0/reference.json": 615,
	"./0.14.0/reference.json": 616,
	"./0.15.0/reference.json": 617,
	"./0.16.0/reference.json": 618,
	"./0.17.0/reference.json": 619,
	"./0.18.0/reference.json": 620,
	"./0.19.0/reference.json": 621,
	"./0.2.0/reference.json": 622,
	"./0.20.0/reference.json": 623,
	"./0.21.0/reference.json": 624,
	"./0.22.0/reference.json": 625,
	"./0.23.0/reference.json": 626,
	"./0.26.0/reference.json": 627,
	"./0.27.0/reference.json": 628,
	"./0.29.0/reference.json": 629,
	"./0.3.0/reference.json": 630,
	"./0.33.0/reference.json": 631,
	"./0.34.0/reference.json": 632,
	"./0.37.0/reference.json": 633,
	"./0.37.1/reference.json": 634,
	"./0.38.0/reference.json": 635,
	"./0.4.0/reference.json": 636,
	"./0.40.0/reference.json": 637,
	"./0.41.0/reference.json": 638,
	"./0.43.0/reference.json": 639,
	"./0.44.0/reference.json": 640,
	"./0.47.0/reference.json": 641,
	"./0.51.0/reference.json": 642,
	"./0.52.0/reference.json": 643,
	"./0.54.0/reference.json": 644,
	"./0.55.0/reference.json": 645,
	"./0.55.1/reference.json": 646,
	"./0.58.1/reference.json": 647,
	"./0.59.3/reference.json": 648,
	"./0.59.4/reference.json": 649,
	"./0.6.0/reference.json": 650,
	"./0.7.0/reference.json": 651,
	"./0.9.0/reference.json": 652
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;


//////////////////
// WEBPACK FOOTER
// ./~/camshaft-reference/versions ^\.\/.*\/reference\.json$
// module id = 613
// module chunks = 0 1 5